import { combineReducers } from 'redux';

import attachments from './attachments';
import authentications from './authentications';
import carbonCopies from './carbonCopies';
import confirmedThatFieldCannotBeModified from './confirmedThatFieldCannotBeModified';
import exitRoute from './exitRoute';
import expirationDate from './expirationDate';
import fields from './fields';
import host from './host';
import isFieldInserting from './isFieldInserting';
import labelIds from './labelIds';
import participants from './participants';
import reminder from './reminder';
import verifications from './requiredVerificationBySignerId';
import schedule from './schedule';

export default combineReducers({
  attachments,
  authentications,
  confirmedThatFieldCannotBeModified,
  exitRoute,
  expirationDate,
  fields,
  isFieldInserting,
  participants,
  carbonCopies,
  host,
  schedule,
  labelIds,
  verifications,
  reminder,
});
